//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CardPropertyIcon from './CardPropertyIcon.vue'
import ValueChangeField from '../Field/ValueChangeField.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'

export default {
  name: 'CardPropertyValueChange',
  components: {
    ValueChangeField,
    CardPropertyIcon
  },
  mixins: [cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  },
  computed: {
    options: function () {
      const config = this.tabProp || {}
      if (config.componentProps && config.componentProps.options) {
        return config.componentProps.options
      } else {
        return []
      }
    }
  },
  methods: {
    validate: function () {
      return this.$refs.field.validate()
    }
  }
}
